import { fromJS } from 'immutable';

import {
  LOAD_SETTINGS,
  LOAD_SETTINGS_SUCCESS,
  LOAD_SETTINGS_ERROR,
  UPDATE_SETTINGS,
  UPDATE_SETTINGS_SUCCESS,
  UPDATE_SETTINGS_ERROR,
} from './constants';

const initialState = fromJS({
  settings: {},
  loadingSettings: false,
  loadSettingsError: null,
  hasUserSettings: false,
  updateSettingsLoading: false,
  updateSettingsError: false,
});

function userSettingsReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_SETTINGS:
    return state
      .set('settings', fromJS({}))
      .set('loadingSettings', true)
      .set('loadSettingsError', null)
      .set('hasUserSettings', false);
  case LOAD_SETTINGS_SUCCESS:
    return state
      .set('settings', action.data.settings)
      .set('hasUserSettings', action.data.hasUserSettings)
      .set('loadingSettings', false);
  case LOAD_SETTINGS_ERROR:
    return state
      .set('loadSettingsError', action.error)
      .set('loadingSettings', false);
  case UPDATE_SETTINGS:
    return state
      .set('updateSettingsLoading', true)
      .set('updateSettingsError', null);
  case UPDATE_SETTINGS_SUCCESS:
    return state
      .set('updateSettingsLoading', false)
      .setIn(['settings', 'emailType'], action.data.emailType)
      .setIn(['settings', 'emailFrequency'], action.data.emailFrequency);
  case UPDATE_SETTINGS_ERROR:
    return state
      .set('updateSettingsLoading', false)
      .set('updateSettingsError', action.error);
  default:
    return state;
  }
}

export default userSettingsReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/user-settings/reducer.js
 **/